module.exports = __webpack_public_path__ + "static/media/小奶音.04e98c53.flv";